<div class="modal-header">
  <h1 class="modal-title fs-5" id="viewBookingDetailsLabel">Tracking</h1>
  <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
</div>

<div class="modal-body">
  <div *ngIf="booking" class="row row-cols-1 row-cols-md-3 g-2 mb-3">

    <!-- Pick-up card -->
    <div class="col">
      <div class="card h-100 shadow">
        <div class="card-header text-center bg-primary p-0">
          <h2 class="fs-5 text-white m-0">Pick-up address</h2>
        </div>
        <div class="card-body text-center p-1">
          <p class="mb-0 fs-6 text-secondary">
            {{booking.pickUpAddress}}, {{booking.fromSuburb}}, {{booking.pickUpPCode}}
          </p>
        </div>
      </div>
    </div>
    <!-- Pick-up card -->

    <!-- Middle image -->
    <div class="col d-none d-md-block">
      <div class="card h-100 border-0">
        <div class="card-body d-flex justify-content-center align-items-center">
          <div class="col rounded-circle bg-primary" style="height: 1em;"></div>
          <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
          <div class="col rounded-circle bg-primary" style="height: 1em;"></div>
          <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
          <div class="col rounded-circle bg-primary opacity-75" style="height: 1em;"></div>
          <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
          <div class="col rounded-circle bg-primary opacity-50" style="height: 1em;"></div>
          <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
          <div class="col rounded-circle bg-danger opacity-50" style="height: 1em;"></div>
          <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
          <div class="col rounded-circle bg-danger opacity-75" style="height: 1em;"></div>
          <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
          <div class="col rounded-circle bg-danger" style="height: 1em;"></div>
          <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
          <div class="col rounded-circle bg-danger" style="height: 1em;"></div>
        </div>
      </div>
    </div>
    <!-- Middle image -->

    <!-- Drop-off card -->
    <div class="col">
      <div class="card h-100 shadow">
        <div class="card-header text-center bg-danger p-0">
          <h2 class="fs-5 text-white m-0">Drop-off address</h2>
        </div>
        <div class="card-body text-center p-1">
          <p class="mb-0 fs-6 text-secondary">
            {{booking.dropOffAddress}}, {{booking.toSuburb}}, {{booking.dropOffPCode}}
          </p>
        </div>
      </div>
    </div>
    <!-- Drop-off card -->

  </div>

  <div class="card shadow mb-4">
    <div class="card-header d-flex flex-column d-md-flex flex-md-row justify-content-md-between">
      <h4 class="text-danger m-0">Tracking events</h4>
      <h4 class="text-danger m-0">{{trackNo.trackNo}}</h4>
    </div>

    <div class="card-body">
      <!-- Table of parcels -->
      <div class="col text-center px-2 mt-2">
        <div *ngIf="trackingEvents?.length > 0" class="table-responsive rounded-2">
          <table class="table table-hover table-sm align-middle">
            <thead>
            <tr>
              <th class="text-secondary">No</th>
              <th class="text-secondary">Description</th>
              <th class="text-secondary">Date</th>
              <th class="text-secondary">Time</th>
              <th class="text-secondary">Branch</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let trackEvent of trackingEvents; let i = index" class="table-light">
              <td class="text-secondary">{{i + 1}}</td>
              <td  class="text-secondary">{{trackEvent.WaybillEventDescription}}</td>
              <td  class="text-secondary">{{trackEvent.WaybillEventDate}}</td>

              <td  class="text-secondary">{{trackEvent.WaybillEventTime}}</td>
              <td  class="text-secondary">{{trackEvent.WaybillEventBranch}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <!-- <ng-template #noEvents>
          <p class="text-secondary">No order events yet</p>
        </ng-template> -->
      </div>
    </div>
  </div>
</div>

<div class="modal-footer d-flex justify-content-between">
  <button type="button" class="btn btn-danger w-25" (click)="closeModal()">
    Close
  </button>
</div>

<!--<div class="container d-lg-flex">

  &lt;!&ndash; Tracking content &ndash;&gt;
  <div class="container-fluid pt-3">
    <div class="row">
      <div class="col">

        <div class="row row-cols-1 row-cols-md-3 g-2 mb-3">

          &lt;!&ndash; Pick-up card &ndash;&gt;
          <div class="col">
            <div class="card h-100 shadow">
              <div class="card-header text-center bg-primary p-0">
                <h2 class="fs-5 text-white m-0">Pick-up address</h2>
              </div>
              <div class="card-body text-center p-1">
                <p class="mb-0 fs-6 text-secondary">
                  {{booking.pickUpAddress}}, {{booking.fromSuburb}}, {{booking.pickUpPCode}}
                </p>
              </div>
            </div>
          </div>
          &lt;!&ndash; Pick-up card &ndash;&gt;

          &lt;!&ndash; Middle image &ndash;&gt;
          <div class="col d-none d-md-block">
            <div class="card h-100 border-0">
              <div class="card-body d-flex justify-content-center align-items-center">
                <div class="col rounded-circle bg-primary" style="height: 1em;"></div>
                <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
                <div class="col rounded-circle bg-primary" style="height: 1em;"></div>
                <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
                <div class="col rounded-circle bg-primary opacity-75" style="height: 1em;"></div>
                <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
                <div class="col rounded-circle bg-primary opacity-50" style="height: 1em;"></div>
                <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
                <div class="col rounded-circle bg-danger opacity-50" style="height: 1em;"></div>
                <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
                <div class="col rounded-circle bg-danger opacity-75" style="height: 1em;"></div>
                <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
                <div class="col rounded-circle bg-danger" style="height: 1em;"></div>
                <div class="col rounded-circle bg-transparent" style="height: 1em;"></div>
                <div class="col rounded-circle bg-danger" style="height: 1em;"></div>
              </div>
            </div>
          </div>
          &lt;!&ndash; Middle image &ndash;&gt;

          &lt;!&ndash; Drop-off card &ndash;&gt;
          <div class="col">
            <div class="card h-100 shadow">
              <div class="card-header text-center bg-danger p-0">
                <h2 class="fs-5 text-white m-0">Drop-off address</h2>
              </div>
              <div class="card-body text-center p-1">
                <p class="mb-0 fs-6 text-secondary">
                  {{booking.dropOffAddress}}, {{booking.toSuburb}}, {{booking.dropOffPCode}}
                </p>
              </div>
            </div>
          </div>
          &lt;!&ndash; Drop-off card &ndash;&gt;

        </div>

        <div class="card shadow mb-4">
          <div class="card-header d-flex justify-content-between">
            <h2 class="text-danger m-0">Tracking events</h2>
            <h2 class="text-danger m-0">{{booking.waybillResponse.waybillNumber}}</h2>
          </div>

          <div class="card-body">
            &lt;!&ndash; Table of parcels &ndash;&gt;
            <div class="col text-center px-2 mt-2">
              <div *ngIf="trackingEvents; else noEvents" class="table-responsive rounded-2">
                <table class="table table-hover table-sm align-middle">
                  <thead>
                  <tr>
                    <th class="text-secondary">No</th>
                    <th class="text-secondary">Description</th>
                    <th class="text-secondary">Date</th>
                    <th class="text-secondary">Time</th>
                    <th class="text-secondary">Branch</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let trackEvent of trackingEvents; let i = index" class="table-light">
                    <td class="text-secondary">{{i + 1}}</td>
                    <td  class="text-secondary">{{trackEvent.WaybillEventDescription}}</td>
                    <td  class="text-secondary">{{trackEvent.WaybillEventDate}}</td>

                    <td  class="text-secondary">{{trackEvent.WaybillEventTime}}</td>
                    <td  class="text-secondary">{{trackEvent.WaybillEventBranch}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <ng-template #noEvents>
                <p class="text-secondary">No order events yet</p>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</div>-->
